import React from "react";

const TopSellingHotel = ({ TableData }) => {
  return (
    <div className="p-2 bg-white rounded-md">
      <div className="py-2">
        <p className="text-md font-semibold">Top Selling Hotels</p>
      </div>
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
              #
            </th>

            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
              Hotel
            </th>

            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
              Total Bookings
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
              Total Paid Amount
            </th>
          </tr>
        </thead>

        <tbody className="bg-white divide-y divide-gray-200">
          {TableData?.topHotelByAmount?.length > 0 ? (
            <>
              {TableData?.topHotelByAmount?.map((item, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-sm text-gray-700">
                    {index + 1}
                  </td>

                  <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                    {item?.hotelName?.slice(0, 12)}...
                  </td>

                  <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                    {item.totalAmount || 0}
                  </td>

                  <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                    {item.paidAmount || 0}
                  </td>
                </tr>
              ))}
            </>
          ) : (
            <>
              <tr>
                <td
                  colSpan={4}
                  className="px-4 py-3 text-sm text-center text-gray-700 text-nowrap"
                >
                  No Data to Show
                </td>
              </tr>
            </>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TopSellingHotel;
